import React from 'react';

const SignUpInfo = ({ info }) => (
  <div className="row margin-bottom-20 line-height-extra">
    <div className="col-xs-1">
      <span className="iconified-font iconified-checkmark text-color-green" />
    </div>
    <div className="col-xs-10 text-size-14 text-weight-light">
      { info }
    </div>
  </div>
);

export default SignUpInfo;
